export default "__VITE_ASSET__CPaVeHb___"